import type { ErrorComponentProps } from "@tanstack/react-router";

import { ForbiddenError } from "@/features/errors/forbidden";
import { GeneralError } from "@/features/errors/general-error";
import { NotFoundError } from "@/features/errors/not-found-error";
import { UnauthorisedError } from "@/features/errors/unauthorized-error";
import {
  MissingSearchParameterError,
  OrganizationNotFoundError,
  PermissionDeniedError,
  StripeError,
} from "@/lib/error";

export function UnknownError({ error }: ErrorComponentProps) {
  if (error instanceof PermissionDeniedError) {
    return <ForbiddenError />;
  }

  if (error instanceof OrganizationNotFoundError) {
    return <UnauthorisedError />;
  }

  if (error instanceof NotFoundError) {
    return <UnauthorisedError />;
  }

  if (error instanceof MissingSearchParameterError) {
    return <GeneralError />;
  }

  if (error instanceof StripeError) {
    return <GeneralError />;
  }

  return <GeneralError error={error} />;
}
